@if (activeTab === 'view' && !getDataExist() && !noIncidentsDetected()) {
	<div class="detect-incidents">
		<button
			[disabled]="disabledButton()"
			mat-flat-button
			class="mat-flat-btn-font-correction detect-incidents-btn"
			[ngClass]="changeButtonColor()"
			(click)="detectionTask() ? this.viewSelected() : this.detectIncidents()"
		>
			@if (buttonName() === 'Analyzing...') {
				<mat-icon svgIcon="progress_activity" class="mr-r-sxs icon-rotate"></mat-icon>
			}
			@if (buttonName() !== 'Analyzing...') {
				<mat-icon
					[svgIcon]="noIncidentsDetected() ? 'report_sign' : 'frame_inspect'"
					class="mr-r-sxs"
				></mat-icon>
			}
			<span>{{ buttonName() }}</span>
		</button>
	</div>
}
